import { axiosBasic, axiosBearer } from "../config/axios-common";
import AcademicDegree from "../models/AcademicDegree";

const postInsertOrUpdateAcademic = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/academicdegree/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const CreateAndGetAcademicDegreeFromTasy = async (requestId: string): Promise<AcademicDegree[]> => {

    const response = await axiosBearer.post(`/sam/v1/academicdegree/CreateAndGetAcademicDegreeFromTasy?requestId=${encodeURIComponent(requestId)}`, {}).then(response => {

        var result = new Array<AcademicDegree>();

        if (response.data !== undefined && response.data.length > 0) {

            result = response.data.map((row: any) => {
                let item = AcademicDegree.NewInstance();

                item.Id = row.id;
                item.TitleId = row.titleId;
                item.TitleValue = row.titleValue;
                item.InstitutionName = row.institutionName;
                item.CourseName = row.courseName;
                item.YearCompletion = row.yearCompletion;
                item.TasyCode = row.tasyCode;
                item.RemoveTasy = row.removeTasy;

                return item;
            });
        }

        return result;
    })

    const responseData = await response;

    return responseData;

};



const exportedObject = {
    postInsertOrUpdateAcademic,
    CreateAndGetAcademicDegreeFromTasy
};


export default exportedObject